import { useState } from "react";
import countries from "world-countries";
import { truncate } from "../../../../utils";
import {
  LoanProductType,
  MediaPurpose,
  Vendor,
} from "../../../../hooks/api/types";
import { getVendorTitle } from "../../../LoanApplicationSteps/VendorInformation/utils";
import { Modal } from "../../../../components";

interface VendorListSectionProps {
  title: "Approved" | "Pending";
  vendors: Array<Vendor>;
  loanType: LoanProductType;
  showLicenseNumber?: boolean;
}

const VendorListSection = ({
  title,
  vendors,
  loanType,
  showLicenseNumber = false,
}: VendorListSectionProps) => {
  const [previewMode, setPreviewMode] = useState<boolean>(false);
  const [previewUrl, setPreviewUrl] = useState<string>("");
  const [previewTitle, setPreviewTitle] = useState<string>("");

  const handleViewDocument = (url: string, vendorName: string) => {
    setPreviewUrl(url);
    setPreviewTitle(`${vendorName} - Trade License`);
    setPreviewMode(true);
  };

  return (
    <>
      <div className="cx-bg-white cx-rounded-lg cx-w-full cx-p-10 cx-mb-6">
        <div className="cx-flex cx-flex-row cx-place-content-between cx-w-full cx-mb-6">
          <div className="cx-text-xl cx-font-bold">
            {title} {getVendorTitle(loanType)}s
          </div>
        </div>
        <div className="cx-grid cx-grid-cols-2 cx-gap-4 cx-w-full">
          {vendors.map((vendor: Vendor) => {
            const tradeLicense = vendor.documents?.find(
              (doc) => doc.documentPurpose === MediaPurpose.VENDOR_TRADE_LICENSE
            );

            return (
              <div
                className="cx-flex cx-flex-row cx-items-center cx-justify-between cx-p-4 cx-border cx-border-stroke-primary cx-rounded-base"
                key={vendor.id}
              >
                <div className="cx-flex cx-flex-row cx-items-center cx-content-center cx-w-full">
                  <div className="cx-font-bold cx-text-xl">
                    {
                      countries.find(
                        (country) => country.cca3 === vendor.country
                      )?.flag
                    }
                  </div>
                  <div
                    className={`cx-flex ${
                      showLicenseNumber
                        ? "cx-flex-col cx-gap-1"
                        : "cx-flex-row cx-justify-between"
                    } cx-w-full cx-ml-4`}
                  >
                    <div className="cx-font-medium cx-text-base">
                      {truncate(vendor.name, 40)}
                    </div>
                    {showLicenseNumber && (
                      <div className="cx-font-medium cx-text-base">
                        {vendor.licenseNumber}
                      </div>
                    )}
                    {showLicenseNumber && tradeLicense && (
                      <button
                        className="cx-text-brand-primary-regular cx-text-sm cx-font-medium cx-text-left hover:cx-underline"
                        onClick={() =>
                          handleViewDocument(
                            tradeLicense.documentUrl,
                            vendor.name
                          )
                        }
                      >
                        View Trade License
                      </button>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <Modal
        isOpen={previewMode}
        onClose={() => setPreviewMode(false)}
        title={truncate(previewTitle, 45)}
        className={"cx-max-w-[960px]"}
      >
        <iframe
          src={previewUrl}
          style={{ width: 576, height: 768 }}
          frameBorder="0"
        ></iframe>
      </Modal>
    </>
  );
};

export default VendorListSection;
